export enum PASSWORD_ERRORS {
  noLowercase = 'noLowercase',
  noUppercase = 'noUppercase',
  noNumberOrSpecial = 'noNumberOrSpecial',
  minlength = 'minlength',
  beenUsed = 'beenUsed',
}
